import { Button, Stack, Typography, useTheme } from '@mui/material';
import React from 'react';

export interface ColumnSelectionEmptyStateProps {
  /** The trimmed search text, if any — absent means the list itself is empty. */
  query: string;
  /** False when the page supplied no columns at all, so there is nothing to clear back to. */
  hasColumns: boolean;
  onClear: () => void;
}

export const ColumnSelectionEmptyState: React.FC<ColumnSelectionEmptyStateProps> = ({
  query,
  hasColumns,
  onClear,
}) => {
  const theme = useTheme();

  return (
    <Stack alignItems="center" spacing={1} sx={{ p: 4 }}>
      <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
        {!hasColumns
          ? 'No columns are available for this list.'
          : query
            ? `No columns match "${query}".`
            : 'No columns are selected yet.'}
      </Typography>
      {hasColumns && (
        <Button
          size="small"
          onClick={onClear}
          sx={{ color: theme.palette.v4.accentDark, textTransform: 'none' }}
        >
          {/* Deliberately not "Clear search": the search box has its own clear
              button, and two controls sharing a name is ambiguous to a screen
              reader. This one also drops the selected-only filter. */}
          Show all columns
        </Button>
      )}
    </Stack>
  );
};
